module.exports = {"title":"Shipping"}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal.json
// module id = 1846
// module chunks = 7 16